





































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { TipoLesaoQuantidade } from '@/types/_'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'
import _ from 'lodash'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'

@Component

export default class ComponentModalSolicitacaoTipoLesao extends Vue {
  inputSearch: string = ''
  loading: any = {
    searchProcedimento: false,
    listText: '',
  }

  get getSolicitacaoCirurgiaStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }

  get getTipoLesaoApi() {
    return this.getSolicitacaoCirurgiaStore.tipoLesaoApi
  }

  get getInputSearch() {
    return this.inputSearch
  }

  set getInputSearch(value) {
    this.inputSearch = value
  }

  get getShowModalTipoDeLesao() {
    return this.getSolicitacaoCirurgiaStore.modal.showTipoDeLesao
  }

  get getTipoLesao() {
    return this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.lesoes || []
  }

  @Watch('getShowModalTipoDeLesao')
  onChangeGetShowModalTipoLesao(value) {
    setTimeout(() => {
      const input = document.querySelector('.procedimento-input input') as HTMLInputElement
      if (value) {
        this.getInputSearch = ''
        input.focus()
      } else {
        input.blur()
      }
    }, 100)
  }

  save() {
    this.getInputSearch = ''
    this.getSolicitacaoCirurgiaStore.setModal({ name: 'showTipoDeLesao', value: false })
  }

  closeModalTipoLesao() {
    this.getSolicitacaoCirurgiaStore.setModal({ name: 'showTipoDeLesao', value: false })
  }

  selectLesao(lesao) {
    this.getSolicitacaoCirurgiaStore.setTipoLesaoQuantidade(lesao)
    this.getSolicitacaoCirurgiaStore.setModal({ name: 'showTipoLesaoQuantidade', value: true })
  }

  addLesaoFinal(data: TipoLesaoQuantidade) {
    const check = this.getTipoLesao.some(l => l.id === (data.id || data.lesaoId))
    if (!check) {
      this.getSolicitacaoCirurgiaStore.setAddLesao(data)
    }

    this.getSolicitacaoCirurgiaStore.removeTipoLesaoApi(data)
  }


  removeTipoLesaoSelecionada(lesao: TipoLesaoQuantidade) {
    this.getSolicitacaoCirurgiaStore.removeLesao(lesao)
    this.getSolicitacaoCirurgiaStore.addTipoLesaoApi(lesao)
  }

  debounce = _.debounce(input => this.getSolicitacaoCirurgiaStore.getTipoLesaoSearch(input), 600)

  search() {
    if (this.getInputSearch.length === 0 || this.getInputSearch.length > 2) {
      this.debounce(this.getInputSearch)
    }
  }
}

